import React from "react";
import "../styles/PolaroidCamera.css"; // Plik CSS dla kamery

const PolaroidCamera = () => {
  return (
    <div className="polaroid-camera">
      {/* 🔴 Przycisk jest wewnątrz aparatu */}
      <div className="button"></div>

      {/* 📸 Ciało aparatu */}
      <div className="flash"></div>
      <div className="polaroid-body">
        <div className="blinker"></div>
        <div className="zoom">
          <div className="outer-lens"></div>
          <div className="inner-lens"></div>
        </div>
        <div className="stripes"></div>
      </div>
      <div className="flashlight"></div>
    </div>
  );
};

export default PolaroidCamera;
